// MB-I18N-1 — Interpolation robuste des placeholders {param} (syntaxe inchangée).
// Remplace TOUTES les occurrences ; 0 et false sont des valeurs valides ;
// un paramètre absent conserve le placeholder ; la valeur n'est jamais interprétée comme regex.

export function interpolateTranslation(message, params) {
  if (typeof message !== 'string') return message;
  if (!params || typeof params !== 'object') return message;

  return message.replace(/\{(\w+)\}/g, (match, key) => {
    if (!Object.prototype.hasOwnProperty.call(params, key)) return match;
    const value = params[key];
    if (value === null || value === undefined) return match;
    return String(value);
  });
}
